import React, { Component } from 'react';
import { Close, Done, PriorityHigh } from '@material-ui/icons';
import { Trans, withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import styles from '../../assets/jss/customMessageStyles';

class CustomMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: false,
    };
  }

  hideSuccessMessage = (e) => {
    e.preventDefault();

    const { history } = this.props;
    const { hide } = this.state;

    history.state = {
      status: 'success',
      msg: 'TOASTER.EMAIL_SUCCESS',
      show: false,
    };
    this.setState({ hide: !hide });
  };

  render() {
    const {
      classes,
      history,
    } = this.props;
    const state = history && history.state ? history.state : {};
    let icon;
    if (state && state.status) {
      switch (state.status) {
        case 'error':
          icon = <Close />;
          break;
        case 'success':
          icon = <Done />;
          break;
        case 'warning':
          icon = <PriorityHigh />;
          break;
        default:
          icon = <Close />;
      }
    }

    return (
      <div>
        {state && state.show
          ? (
            <div className={`${classes.message} ${classes[state.status]}`} style={{ width: 'auto' }}>
              {icon}
              <h5><Trans i18nKey={state.msg} /></h5>
              <p aria-hidden="true" onClick={this.hideSuccessMessage}><strong>x</strong></p>
            </div>
          ) : null}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles, { withTheme: true })(CustomMessages));
